import { useEffect } from 'react';
import { useStore } from 'react-redux';
import getInjectors from 'utils/sagaInjectors';

const useInjectSagas = (sagas) => {
  const store = useStore();

  useEffect(() => {
    const { injectSaga, ejectSaga } = getInjectors(store);

    sagas.forEach(({ key, saga, mode }) => {
      injectSaga(key, { saga, mode });
    });

    return () => {
      sagas.forEach(({ key }) => {
        ejectSaga(key);
      });
    };
  }, [store]);
};

export default useInjectSagas;
